import { useState } from "react";
import VisitorCounter from "../common/VisitorCounter";

function HeroSection() {
  const [imageFailed, setImageFailed] = useState(false);

  return (
    <section className="hero" id="top">
      <div className="wrap hero-grid">
        <div className="hero-head reveal">
          <VisitorCounter />
          <span className="badge">
            <span className="pulse" />
            가입부터 평생관리까지, 한 사람이 끝까지
          </span>
          <h1>
            당신의 보험,
            <br />
            <span className="highlight">누구에게</span> 맡기시겠어요?
          </h1>
        </div>

        <div className="portrait-col reveal">
          <div className="portrait">
            {!imageFailed ? (
              <img
                src="/lee.png"
                alt="이동은 보험설계사 프로필"
                onError={() => setImageFailed(true)}
              />
            ) : (
              <div className="portrait-fallback">
                <div>
                  <b>이</b>
                  <small>프로필 사진 준비 중</small>
                </div>
              </div>
            )}
          </div>
          <div className="nameplate">
            <b>이동은</b>
            <span>보험설계사</span>
          </div>
        </div>

        <div className="hero-body reveal">
          <p className="lead">
            보험은 상품이 아니라 <b>사람</b>입니다. 좋은 상품을 고르는 것보다 더
            중요한 건, <strong>끝까지 곁에서 관리해 줄 사람</strong>이
            있느냐입니다. 이동은이 그 한 사람이 되어 드리겠습니다.
          </p>
          <div className="trust-row">
            <div>
              <b>1:1</b>
              <span>전담 평생관리</span>
            </div>
            <div>
              <b>정직</b>
              <span>강요 없는 상담</span>
            </div>
            <div>
              <b>동행</b>
              <span>보험금 청구까지</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
